import { useEffect, useState } from 'react';

// Provides a key that can be used to force components to re-render based on a dependency
export const useDependentKey = (dependency) => {
  const [gridKey, setGridKey] = useState(false);
  useEffect(() => {
    setGridKey((prev) => !prev);
  }, [dependency]);

  return gridKey;
};
